import { Dealer } from "../../dealer/shared/dealer.model";
import { Country } from "../../postal/country.model";
import { AddressableUser } from "../../user/addressable-user.model";

export class Employee extends AddressableUser {

    public static override stringifyExclude: string[] = [
        "_dealer_id",
        "_dealer"
    ];

    private _dealer_id: number = -1;
    private _dealer: Dealer | null | undefined;

    public get dealer_id(): number {
        return this._dealer_id;
    }

    public set dealer_id(value: number) {
        this._dealer_id = value;
    }

    public get dealer(): Dealer | null | undefined {
        return this._dealer;
    }

    public set dealer(value: Dealer) {
        this._dealer = value;
    }

    public override getStringifyExclude(): string[] {
        return Employee.stringifyExclude;
    }
    
    public override toJSON(): Object;
    public override toJSON(stringifyExclude: string[] | string): Object;
    public override toJSON(stringifyExclude?: string[] | string): Object {
        return super.toJSON(stringifyExclude == undefined || stringifyExclude == "" ? Employee.stringifyExclude : stringifyExclude as string[]);
    }

    public static toEmployees(obj: string | Object[]): Employee[] {
        let obj2 = obj;

        // If not string, then assumption is an
        // array of objects.
        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        let employees: Employee[] = [];

        for (const o2 of (<Object[]>obj2)) {
            employees.push(Employee.toEmployee(o2));
        }

        return employees;
    }

    public static toEmployee(obj: string | Object): Employee {
        let obj2 = obj;

        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        // Convert generic object to type of Employee.
        let employee = Object.assign(new Employee(), obj2);

        if (employee.country != null) {
            employee.country = Country.toCountry(employee.country);
        }

        if (employee.dealer != null) {
            employee.dealer = Dealer.toDealer(employee.dealer);
        }

        return employee;
    }
}    
